"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _ = require("../../..");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const HeaderCell = ({
  align = 'left',
  sortable,
  sortOrder,
  children,
  onSortChange,
  ascendingReturnValue = 'asc',
  descendingReturnValue = 'desc',
  noSortReturnValue = '',
  revertOrder
}) => {
  const justify = align === 'right' ? 'flex-end' : align;
  const sortIcon = sortOrder === 'asc' ? (0, _jsxRuntime.jsx)(_.IconCaretUp, {}) : (0, _jsxRuntime.jsx)(_.IconCaretDown, {});
  const SortButton = children && (0, _jsxRuntime.jsx)(_.Button, {
    nostyle: true,
    css: (0, _styles.SortButtonStyle)(sortOrder !== 'none'),
    onClick: () => sortable && onSortChange && onSortChange(sortOrder === 'asc' ? revertOrder ? descendingReturnValue : noSortReturnValue : sortOrder === 'desc' ? revertOrder ? noSortReturnValue : ascendingReturnValue : revertOrder ? ascendingReturnValue : descendingReturnValue),
    afterIcon: sortIcon,
    children: children
  });
  return (0, _jsxRuntime.jsx)(_styles.Wrapper, {
    justify: justify,
    className: "table-cell",
    children: sortable ? SortButton : children
  });
};
var _default = exports.default = HeaderCell;